<template>
  <div v-if="accreditation">
    <div class="a-container-form ">
      <div class="a-label ">{{$t('form.accreditation.status')}}:</div>
      <p class="a-input a-input--disabled " v-t="acc.state.label "></p>
    </div>
    <div class="a-container-form a-container-form--align-start" v-if="acc.expired">
      <div class="a-label ">{{$t('form.accreditation.due-date')}}:</div>
      <date-time class="a-input a-input--disabled" :value="acc.expired" :time="false"></date-time>
    </div>
    <div class="a-container-form a-container-form--align-start u-padding-bottom-0" v-if="acc.documents">
      <div class="a-label ">{{$t('form.accreditation.documents')}}:</div>
      <div class="accreditation__file-group">
        <div class="a-input-file-block accreditation__block" v-for="(doc, idx) in $v.acc.documents.$each.$iter" :key="doc.$model.id">
          <p class="a-input a-input--disabled ">{{idx + 1}}. {{doc.$model.name}}</p>

          <div class="a-container-form " v-if="doc.$model.passport">
            <div class="a-label a-label--w-280">{{$t('form.accreditation.document-and-signature-expiration-date')}}:</div>
            <date-time class="a-input a-input--disabled" :value="doc.$model.expirationDate"></date-time>
          </div>

          <div class="a-container-form "
               v-if="doc.$model.passport">
            <div class="a-label a-label--w-280">{{$t('form.accreditation.choose-period-for-notifying-of-the-org-about-expiration-of-power-of-attorney')}}</div>
            <template v-if="canChangeAccState">
              <input-number class="select-w-77" :maxDigits="5" v-model="doc.$model.days"></input-number>
              <p class="u-padding-left-20" style="padding-top: 8px;">{{$t('labels.calendar_days')}}</p>
            </template>
            <p class="a-input a-input--disabled " v-else>{{$tc('labels.n_calendar_days', doc.$model.days)}}</p>
          </div>

          <file-link :name="file.name"
                     :size="file.size"
                     :link="externalLink(file.uid)"
                     :removable="false"
                     :key="file.uid"
                     :signed="file.hasSign"
                     @onsigncheck="onSignCheckClick(doc.$model.id, file.id)"
                     v-for="file in doc.$model.files">
          </file-link>

          <div class="accreditation__select-textarea a-form-field">
            <dropdown-new class="accreditation__status" v-model="doc.$model.state" :disabled="!canChangeAccState">
              <option :value="enums.AccreditationDocumentState.DRAFT" :label="'accreditation-document-state.draft'" disabled></option>
              <option :value="enums.AccreditationDocumentState.REGISTERED" :label="'accreditation-document-state.registered'" disabled></option>
              <option :value="enums.AccreditationDocumentState.APPROVED" :label="'accreditation-document-state.approved'"></option>
              <option :value="enums.AccreditationDocumentState.DECLINED" :label="'accreditation-document-state.declined'"></option>
            </dropdown-new>
            <span class="a-validation-error" v-if="doc.state.$dirty && !doc.state.validState">{{$t('form.accreditation.document-should-be-approved-or-declined')}}</span>
            <div class="accreditation__error-doc" v-if="!canChangeAccState && doc.$model.state == enums.AccreditationDocumentState.DECLINED && doc.$model.reason">{{$t('labels.reason')}}: {{doc.$model.reason}}</div>

            <textarea class="a-textarea accreditation__textarea" rows="2" placeholder="Причина отклонения" v-if="canChangeAccState && doc.$model.state == enums.AccreditationDocumentState.DECLINED" v-model="doc.$model.reason"></textarea>
            <span class="a-validation-error" v-if="doc.reason.$dirty && !doc.reason.required">{{$t('labels.mandatory-field')}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="a-container-form a-container-form--align-start u-padding-bottom-0">
      <div class="a-label ">{{$t('form.accreditation.filled-request')}}:</div>
      <div class="a-input a-input--disabled u-width-100">
        № {{acc.id}}
        <span type="button" class="gui-btn-none-style"
              @click="onAccreditationSignCheckClick()"
              v-if="acc.hasSign">
            <img class="accreditation__reg-img" src="@/assets/img/static/b-icon_edit.svg" alt="">
        </span>
        <div class="accreditation__select-textarea a-form-field">
          <dropdown-new class="accreditation__status" v-model="acc.state" :disabled="!canChangeAccState">
            <option :value="enums.AccreditationState.DRAFT" :label="'accreditation-state.draft'" disabled></option>
            <option :value="enums.AccreditationState.PROCESSING" :label="'accreditation-state.processing'" disabled></option>
            <option :value="enums.AccreditationState.APPROVED" :label="'accreditation-state.approved'"></option>
            <option :value="enums.AccreditationState.DECLINED" :label="'accreditation-state.declined'"></option>
            <option :value="enums.AccreditationState.NOT_ACTIVE" :label="'accreditation-state.not-active'" :disabled="acc.state.valueOf() !== enums.AccreditationState.APPROVED"></option>
          </dropdown-new>
          <span class="a-validation-error" v-if="$v.acc.state.$dirty && !$v.acc.state.validState">{{$t('form.accreditation.request-should-be-approved-or-declined')}}</span>
          <span class="a-validation-error" v-if="$v.acc.state.$dirty && !$v.acc.state.validDocumentsState">{{$t('form.accreditation.all-documents-should-be-approved')}}</span>
          <div v-if="!canChangeAccState && (acc.state == enums.AccreditationState.DECLINED || acc.state == enums.AccreditationState.NOT_ACTIVE) && acc.reason">
            <div class="accreditation__error-doc">{{$t('labels.reason')}}: {{acc.reason}}</div>
          </div>
          <textarea class="a-textarea accreditation__textarea"
                    rows="2"
                    :placeholder="$t('labels.reason-for-rejection')"
                    v-if="canChangeAccState && (acc.state.valueOf() == enums.AccreditationState.DECLINED || acc.state.valueOf() == enums.AccreditationState.NOT_ACTIVE)"
                    v-model="acc.reason"></textarea>
          <span class="a-validation-error" v-if="$v.acc.reason.$dirty && !$v.acc.reason.required">{{$t('labels.mandatory-field')}}</span>
        </div>
      </div>
    </div>
    <div class="personal-data__btn-block ">
      <button class="gui-btn gui-btn--red gui-btn--w-140" type="button" v-if="canShowSaveButton" @click="onSaveClick">{{$t('buttons.save')}}</button>
      <button class="gui-btn gui-btn--red gui-btn--w-140" style="margin-right: 20px;" type="button" v-if="canShowModifyButton" @click="editable = true">{{$t('buttons.modify')}}</button>
      <button class="gui-btn gui-btn--white-border gui-btn--w-140" type="button" v-if="canShowCancelButton" @click="onCancelClick">{{$t('buttons.cancel')}}</button>
      <button class="gui-btn gui-btn--white-border gui-btn--w-140" type="button" @click="onCheckClick">Проверка</button>
    </div>
    <signature-details-dialog ref="signCheck"></signature-details-dialog>
    <accreditation-check-dialog ref="accCheck"></accreditation-check-dialog>
    <loading v-if="loading"></loading>
  </div>
</template>

<script>
  import AccreditationState from '@/api/types/accreditation-state'
  import AccreditationDocumentState from '@/api/types/accreditation-document-state'
  import _ from 'lodash';
  import { requiredIf } from '@/validators'
  import SignatureDetailsDialog from '@/components/common/dialogs/SignatureDetailsDialog'
  import AccreditationCheckDialog from '@/components/common/dialogs/AccreditationCheckDialog'

  export default {

    components: {
      SignatureDetailsDialog,
      AccreditationCheckDialog
    },

    props: {
      profile: Object,
      accreditation: Object,
    },

    data: () => ({
      acc: undefined,
      editable: false
    }),

    validations: {
      acc: {
        state: {
          validState: (value) => {
            const values = [AccreditationState.APPROVED, AccreditationState.DECLINED,  AccreditationState.NOT_ACTIVE];
            const idx = values.indexOf(value.valueOf());
            return idx !== -1;
          },

          validDocumentsState: function(value) {
            return value + '' === AccreditationState.NOT_ACTIVE ||
              value + '' === AccreditationState.DECLINED ||
              value + '' === AccreditationState.APPROVED && _.every(this.acc.documents, e => e.state + '' === AccreditationDocumentState.APPROVED);
          }
        },
        reason: {
          required: requiredIf(function () {
            return this.acc.state.valueOf() === AccreditationState.DECLINED || this.acc.state.valueOf() === AccreditationState.NOT_ACTIVE;
          })
        },
        documents: {
          $each: {
            state: {
              validState: (value) => {
                const values = [AccreditationDocumentState.APPROVED, AccreditationDocumentState.DECLINED];
                const idx = values.indexOf(value + '');
                return idx !== -1;
              }
            },
            reason: {
              required: requiredIf(function (item) {
                return item.state + '' === AccreditationDocumentState.DECLINED
              })
            }
          }
        }
      }
    },

    beforeMount() {
      this.acc = _.cloneDeep(this.accreditation);
    },

    computed: {
      user() { return this.profile },
      permissions() { return this.user.permissions },

      canChangeAccState() {
        return this.acc.permissions.CAN_CHANGE_DIRECTLY || (this.acc.permissions.CAN_CHANGE_WITH_MODIFY && this.editable);
      },

      canShowSaveButton() {
        return this.acc.permissions.CAN_CHANGE_DIRECTLY || this.editable;
      },

      canShowModifyButton() {
        return this.acc.permissions.CAN_CHANGE_WITH_MODIFY;
      },

      canShowCancelButton() {
        return this.acc.permissions.CAN_CHANGE_DIRECTLY || this.editable;
      }
    },

    methods: {
      onCancelClick() {
        this.acc = _.cloneDeep(this.accreditation);
        this.editable = false;
        this.$v.$reset();
      },

      onSaveClick() {
        this.$v.$touch();
        if (this.$v.$invalid) {
          return;
        }

        this.runAction(async () => {
          try {
            await this.$store.dispatch('updateAccreditationState', {
              userId: this.user.id,
              state: this.acc.state.valueOf(),
              reason: this.acc.reason,
              documents: this.acc.documents.map((doc) => ({
                id: doc.id,
                state: doc.state.valueOf(),
                reason: doc.reason,
                days: doc.days
              }))
            })
          }
          catch(e) {
            console.error('unable to update accreditation state', e);
          }

          this.onCancelClick();
        });
      },

      async onSignCheckClick(documentId, fileId) {
        this.runAction(async () => {
          try {
            const signature = await this.$store.dispatch('checkAccountFileSignature', {
              userId: this.user.id,
              accreditationId: this.acc.id,
              docId: documentId,
              fileId: fileId
            });

            this.$refs.signCheck.open(signature);
          }
          catch(e) {
            console.error('unable to check file signature', e);
            this.globalErrorHandler(e);
          }
        })
      },

      async onAccreditationSignCheckClick() {
        this.runAction(async () => {
          try {
            const signature = await this.$store.dispatch('checkAccountAccreditationSignature', {
              userId: this.user.id,
              accreditationId: this.acc.id
            });

            this.$refs.signCheck.open(signature);
          }
          catch(e) {
            console.error('unable to check accreditation signature', e);
            this.globalErrorHandler(e);
          }
        })
      },

      async onCheckClick() {
        return this.runBlockerAction(async() => {
          try {
            const result = await this.$store.dispatch('checkAccountAccreditation', {
              userId: this.user.id
            });

            this.$refs.accCheck.open(this.user, result);
          }
          catch(e) {
            console.error('unable to check accreditation signature', e);
            this.globalErrorHandler(e);
          }
        });
      }
    }
  }
</script>

<style lang="scss" scoped>
  .a-mandatory {
    .a-label::before {
      content: '*';
      color: #cc061a;
    }
  }
</style>
